import { css } from '@fable/theme'

// @note: This is a temp hack to set the height of the modal to auto on mobile
export const modalHeightAuto = css`
  .modal {
    height: auto !important;
  }
`
